import { render, staticRenderFns } from "./new-partner-pricing-rrp.vue?vue&type=template&id=21c8ade2&scoped=true&"
import script from "./new-partner-pricing-rrp.vue?vue&type=script&lang=js&"
export * from "./new-partner-pricing-rrp.vue?vue&type=script&lang=js&"
import style0 from "./new-partner-pricing-rrp.vue?vue&type=style&index=0&id=21c8ade2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8ade2",
  null
  
)

export default component.exports